import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const style = (state) => ({
  selected: { color: '#0D47A1', fillColor: '#1565C0', fillOpacity: 0.85 },
  free: { color: '#1565C0', fillColor: '#FFFFFF', fillOpacity: 0.9 },
  taken: { color: '#90A4AE', fillColor: '#CFD8DC', fillOpacity: 0.8 },
}[state]);

/** Mappa dei comuni entro il raggio dalla sede: cerchio del raggio e un punto per comune (clic = seleziona). */
export const NearbyComuniMap = ({ origin, radiusKm, items, selected, onToggle, height = 340 }) => {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  const oLat = origin?.latitude;
  const oLng = origin?.longitude;
  useEffect(() => {
    if (!ref.current || mapRef.current || !oLat) return undefined;
    const map = L.map(ref.current, { scrollWheelZoom: false, zoomSnap: 0.25, zoomAnimation: false }).setView([oLat, oLng], 11);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap' }).addTo(map);
    mapRef.current = map;
    layerRef.current = L.layerGroup().addTo(map);
    return () => { map.stop(); map.remove(); mapRef.current = null; layerRef.current = null; };
  }, [oLat, oLng]);

  useEffect(() => {
    const map = mapRef.current;
    const layer = layerRef.current;
    if (!map || !layer || !oLat) return;
    layer.clearLayers();
    const circle = L.circle([oLat, oLng], {
      radius: radiusKm * 1000, color: '#1565C0', weight: 1.5, dashArray: '6 5', fillOpacity: 0.04,
    }).addTo(layer);
    L.circleMarker([oLat, oLng], { radius: 7, color: '#B71C1C', fillColor: '#E53935', fillOpacity: 1 })
      .bindTooltip('Sede del Centro').addTo(layer);
    items.forEach((it) => {
      const state = it.taken_by ? 'taken' : (selected.includes(it.comune) ? 'selected' : 'free');
      const m = L.circleMarker([it.latitude, it.longitude], { radius: 6, weight: 2, ...style(state) })
        .bindTooltip(`${it.comune} · ${it.distance_km} km${it.taken_by ? ` · coperto da ${it.taken_by}` : ''}`)
        .addTo(layer);
      if (!it.taken_by) m.on('click', () => onToggle(it));
    });
    map.fitBounds(circle.getBounds(), { padding: [10, 10], animate: false });
  }, [oLat, oLng, radiusKm, items, selected, onToggle]);

  return <div ref={ref} style={{ height, width: '100%' }} data-testid="nearby-comuni-map" />;
};

export default NearbyComuniMap;
